import { render, staticRenderFns } from "./by_item.vue?vue&type=template&id=0adf8411&scoped=true"
import script from "./by_item.vue?vue&type=script&lang=js"
export * from "./by_item.vue?vue&type=script&lang=js"
import style0 from "./by_item.vue?vue&type=style&index=0&id=0adf8411&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.90.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adf8411",
  null
  
)

export default component.exports